import Interaction from 'ol/interaction/Interaction'
import * as Condition from 'ol/events/condition'
import * as Functions from 'ol/functions'
import * as olArray from 'ol/array'

import Style from 'ol/style/Style'

import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'

import * as Extent from 'ol/extent'

class Zonal extends Interaction {
  constructor (optOptions) {
    super({

    })

    const options = optOptions || {}

    this.viewer = options.viewer
    this.condition_ = options.condition ? options.condition : Condition.singleClick

    this.toggleCondition_ = options.toggleCondition ? options.toggleCondition : Condition.shiftKeyOnly

    this.multi_ = options.multi ? options.multi : false

    this.filter_ = options.filter
      ? options.filter
      : feature => feature.getGeometry().getType() === 'Point'

    this.zonalFilter_ = options.zonalFilter ? options.zonalFilter : Functions.TRUE

    this.hitTolerance_ = options.hitTolerance ? options.hitTolerance : 0

    this.featureOverlay_ = new VectorLayer({
      source: new VectorSource({
        useSpatialIndex: false,
        features: options.features,
        wrapX: options.wrapX,
      }),
      style: options.style
        ? options.style
        : this.getDefaultStyleFunction(),
      updateWhileAnimating: true,
      updateWhileInteracting: true,
    })

    let layerFilter
    if (options.layers) {
      if (typeof options.layers === 'function') {
        layerFilter = options.layers
      } else {
        const layers = options.layers
        layerFilter = layer => layers.includes(layer)
      }
    } else {
      layerFilter = Functions.TRUE
    }

    this.layerFilter_ = layerFilter

    let zonalLayerFilter
    if (options.zonalLayers) {
      if (typeof options.zonalLayers === 'function') {
        zonalLayerFilter = options.zonalLayers
      } else {
        const zonalLayers = options.zonalLayers
        zonalLayerFilter = layer => zonalLayers.includes(layer)
      }
    } else {
      zonalLayerFilter = Functions.TRUE
    }

    this.zonalLayerFilter_ = zonalLayerFilter
  }
}

Zonal.prototype.getFeatures = function () {
  return this.featureOverlay_.getSource().getFeaturesCollection()
}

Zonal.prototype.getHitTolerance = function () {
  return this.hitTolerance_
}

Zonal.prototype.handleEvent = function (mapBrowserEvent) {
  if (!this.condition_(mapBrowserEvent)) {
    return true
  }

  const toggle = this.toggleCondition_(mapBrowserEvent)
  const map = mapBrowserEvent.map
  const features = this.featureOverlay_.getSource().getFeaturesCollection()
  let deselected = []
  let selected = []
  const zonesSelected = []

  map.forEachFeatureAtPixel(mapBrowserEvent.pixel,
    function (feature, layer) {
      if (feature.getGeometry().getType() === 'Polygon' &&
        this.zonalFilter_(feature, layer)) {
        zonesSelected.push(feature)
        return !this.multi_
      }
    }.bind(this), {
      layerFilter: this.zonalLayerFilter_,
      hitTolerance_: this.hitTolerance_,
    })

  if (zonesSelected.length) {
    const extent = zonesSelected.reduce((extent, zone) => {
      return Extent.extend(extent, zone.getGeometry().getExtent())
    }, zonesSelected[0].getGeometry().getExtent().slice())

    this.viewer.getFlatLayers().forEach(layer => {
      if (layer.getSource() instanceof VectorSource && this.layerFilter_(layer)) {
        layer.getSource().forEachFeatureInExtent(extent, feature => {
          if (!this.filter_(feature, layer)) {
            return
          }
          for (let i = 0, l = zonesSelected.length; i < l; ++i) {
            if (zonesSelected[i].getGeometry()
              .intersectsCoordinate(feature.getGeometry().getCoordinates())) {
              selected.push(feature)
              break
            }
          }
        })
      }
    })
  }

  if (!toggle) {
    deselected = features.getArray().filter(item => selected.indexOf(item) === -1)
    selected = selected.filter(item => features.getArray().indexOf(item) === -1)
  } else {
    selected = selected.filter(item => features.getArray().indexOf(item) === -1)
  }

  if (selected.length) {
    features.extend(selected)
  }
  if (deselected.length) {
    deselected.forEach(item => features.remove(item))
  }

  if (selected.length || deselected.length) {
    this.dispatchEvent({ type: 'select', selected, deselected, mapBrowserEvent })
  }
  return Condition.pointerMove(mapBrowserEvent)
}

Zonal.prototype.setHitTolerence = function (hitTolerance) {
  this.hitTolerance_ = hitTolerance
}

Zonal.prototype.setMap = function (map) {
  Interaction.prototype.setMap.call(this, map)
  this.featureOverlay_.setMap(map)
}

Zonal.prototype.getDefaultStyleFunction = function () {
  // TODO ne marche pas
  const styles = Style.createDefaultEditing()
  olArray.extend(styles.Polygon, styles.LineString)
  olArray.extend(styles.GeometryCollection, styles.LineString)

  return function (feature, resolution) {
    if (!feature.getGeometry()) {
      return null
    }
    return styles[feature.getGeometry().getType()]
  }
}

export default Zonal
